"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _neptune = require("./neptune");

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require("./_n");

var _n3 = _interopRequireDefault(_n2);

var _unfetch = require("../../node_modules/unfetch");

var _unfetch2 = _interopRequireDefault(_unfetch);

var _uson = require("../../node_modules/uson");

var _uson2 = _interopRequireDefault(_uson);

var _liquidjs = require("../../node_modules/liquidjs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.liquid = {
  topics: {}
};

_neptune2.default.liquid.createEngine = function () {
  _neptune2.default.liquid.engine = new _liquidjs.Liquid();

  _neptune2.default.liquid.engine.registerFilter("handle", function (v) {
    return v.handle();
  });
  _neptune2.default.liquid.engine.registerFilter("file_url", function (v) {
    return "" + window.Neptune.config.file_url_base + v;
  });
  _neptune2.default.liquid.engine.registerFilter("asset_url", function (v) {
    return "" + window.Neptune.config.asset_url_base + v;
  });
  _neptune2.default.liquid.engine.registerFilter("t", function (v) {
    return v.split(".").reduce(function (o, i) {
      return o[i];
    }, window.Neptune.config.lang);
  });
  _neptune2.default.liquid.engine.registerFilter("money", function (v) {
    return "$ " + (v / 100).toFixed(2);
  });
  if (!!window.Shopify) {
    if (Shopify.currency.active == "EUR") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return (v / 100).toFixed(2) + " \u20AC";
    });
    if (Shopify.currency.active == "GBP") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return "\xA3" + (v / 100).toFixed(2);
    });
    if (Shopify.currency.active == "JPY") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return "\xA5" + v / 100;
    });
    if (Shopify.currency.active == "AUD") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return "$" + (v / 100).toFixed(2) + " AUD";
    });
    if (Shopify.currency.active == "CAD") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return "$" + (v / 100).toFixed(2) + " CAD";
    });
    if (Shopify.currency.active == "CHF") _neptune2.default.liquid.engine.registerFilter("money", function (v) {
      return (v / 100).toFixed(2) + " CHF";
    });
  }

  _neptune2.default.liquid.engine.registerTag("random", {
    parse: function parse(tagToken, remainTokens) {
      this.str = tagToken.args; // name
    },
    render: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(scope, hash) {
        var str;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.liquid.evalValue(this.str, scope);

              case 2:
                str = _context.sent;
                return _context.abrupt("return", _n3.default.random());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return render;
    }()
  });

  var _loop = function _loop(b) {
    _neptune2.default.liquid.engine.registerFilter(b, function (current, modified) {
      if (window.outerWidth >= _n3.default.breakpoints[b]) return modified;
      return current;
    });
  };

  for (var b in _n3.default.breakpoints) {
    _loop(b);
  }

  _neptune2.default.liquid.engine.registerFilter("fraction", function (v) {
    return _n3.default.fraction(v);
  });
  _neptune2.default.liquid.engine.registerFilter("feet", function (v) {
    return Math.floor(v / 12) + "' " + (v %= 12) + "\"";
  });

  _n3.default.trigger(document, "liquid:ending", false, true, {});

  return _neptune2.default.liquid.engine;
};

_neptune2.default.liquid.init = function (p) {

  _neptune2.default.liquid.items = _neptune2.default.liquid.topics;

  p = p || document;

  _neptune2.default.liquid.engine = _neptune2.default.liquid.createEngine();

  // if (!_n.exists("[neptune-template],[neptune-liquid]", p)) return false;

  _neptune2.default.debug.info("liquid:init", { el: p });

  var to_render = [];

  // on init cycle through elements with neptune-template IN REVERSE
  _n3.default.array(_n3.default.qsa("[neptune-template],[neptune-liquid]", p)).reverse().forEach(function (t) {
    var att = "neptune-liquid";
    if (t.getAttribute("neptune-template")) att = "neptune-template";

    var config = _uson2.default.parse(t.getAttribute("" + att), "object");

    if (!!!_neptune2.default.liquid.topics[config.topic]) {
      _neptune2.default.liquid.topics[config.topic] = config;
      _neptune2.default.liquid.topics[config.topic].targets = [];
    }
    // add them to the targets of the topic item, including the parent 

    t.topic = config.topic;
    // add the topic to the element

    var exists = false;
    var theHTML = t.innerHTML.trim().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&');
    t.innerHTML = '';

    _neptune2.default.liquid.topics[config.topic].targets.forEach(function (target) {
      target.el.innerHTML = '';
      // console.log('looking for target',target.el,t,(target.el == t))
      if (target.el == t) exists = true;
    });
    if (!exists) {
      _neptune2.default.liquid.topics[config.topic].targets.push({ el: t, template: theHTML, parent: p });
      if (!to_render.includes(config.topic)) to_render.push(config.topic);
    }
    t.setAttribute('neptune-templated', 'true');

    if (!!config.subscribe) {
      document.addEventListener("templates:render", function (e) {
        if (e.detail.info.topic == config.subscribe) _neptune2.default.liquid.load(config.topic);
      });
    }
  });

  // after all registration has occurred, load/render it up the data from the various sources including remote api calls, window reductions, and appendices
  to_render.reverse().forEach(function (item) {
    _neptune2.default.liquid.load(item);
  });

  _neptune2.default.liquid.attributes.init();
};

_neptune2.default.liquid.load = function (topic, data, placement) {

  var config = _neptune2.default.liquid.topics[topic];

  if (!!!config) return false;

  data = data || config.data;

  var source = data || config.source;

  if (typeof source == "string" && source.includes("url:")) {
    return (0, _unfetch2.default)(source.replace("url:", ""), {}).then(function (r) {
      return r.json();
    }).then(function (d) {
      if (!!config.append) {
        _n3.default.array(config.append).forEach(function (appendix) {
          if (!!_neptune2.default.liquid.topics[appendix]) d[appendix] = _neptune2.default.liquid.topics[appendix].data;
          if (!!appendix.split(".").reduce(function (o, i) {
            return o[i];
          }, window)) d[appendix] = appendix.split(".").reduce(function (o, i) {
            return o[i];
          }, window);
        });
      }
      _neptune2.default.liquid.topics[topic].data = d;
      _neptune2.default.liquid.render(topic, null, placement);
    });
  } else {
    if (typeof source == "string" && !source.includes("_self")) {
      _neptune2.default.liquid.topics[topic].data = source.split(".").reduce(function (o, i) {
        return o[i];
      }, window);
    } else {
      if (!!data) {
        _neptune2.default.liquid.topics[topic].data = data;
      } else {
        _neptune2.default.liquid.topics[topic].data = window;
      }
    }
    return _neptune2.default.liquid.render(topic, null, placement);
  }
};

_neptune2.default.liquid.render = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(topic, callback, placement, clearPermanent) {
    var data;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!!!_neptune2.default.liquid.topics[topic] || !!!_neptune2.default.liquid.topics[topic].data)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", false);

          case 2:
            data = _neptune2.default.liquid.topics[topic].data;


            if (Array.isArray(data)) data = { sourceData: data };

            if (!!_neptune2.default.liquid.topics[topic].map) data = _n3.default.map(data, _neptune2.default.liquid.topics[topic].map);

            placement = placement || "contents";

            _n3.default.trigger(document, "templates:render", false, true, {
              topic: topic,
              topics: _neptune2.default.liquid.topics[topic],
              data: data
            });

            _neptune2.default.liquid.topics[topic].targets = _neptune2.default.liquid.topics[topic].targets.filter(function (target) {
              return true;
              // return target.el.parent.includes(target.el)
            });

            _neptune2.default.liquid.topics[topic].targets.forEach(function (item) {
              _neptune2.default.debug.info("templates:render", {
                topic: topic,
                el: item.el,
                topics: _neptune2.default.liquid.topics[topic],
                data: data
              });

              // here we look for data that is local to the element using "_self" or ._parent(qs)
              if (!!_neptune2.default.liquid.topics[topic].source && typeof _neptune2.default.liquid.topics[topic].source == "string" && _neptune2.default.liquid.topics[topic].source.includes("_self")) {
                data = eval(_neptune2.default.liquid.topics[topic].source.replace("_self", "item.el"));
              }
              if (!!_neptune2.default.liquid.topics[topic].source && !!_neptune2.default.liquid.topics[topic].source._parent) {
                data = _n3.default.parents(item.el, _neptune2.default.liquid.topics[topic].source._parent);
              }

              if (!!_neptune2.default.liquid.topics[topic].source && !!_neptune2.default.liquid.topics[topic].source.selector) {
                data = _n3.default.qs(_neptune2.default.liquid.topics[topic].source.selector);
              }

              // // here we look to
              // if(!!Neptune.liquid.topics[topic].source && typeof Neptune.liquid.topics[topic].source == 'string' && Neptune.liquid.topics[topic].source.includes('qs(')){
              //   data = _n.qs(Neptune.liquid.topics[topic].source.split('qs(')[1].split(')')[0])
              //   console.log(Neptune.liquid.topics[topic].source,data)
              // }

              if (!!_neptune2.default.liquid.topics[topic].append) {
                _n3.default.array(_neptune2.default.liquid.topics[topic].append).forEach(function (appendix) {
                  if (!!_neptune2.default.liquid.topics[appendix]) data[appendix] = _neptune2.default.liquid.topics[appendix].data;
                  if (!!appendix.split(".").reduce(function (o, i) {
                    return o[i];
                  }, window)) data[appendix] = appendix.split(".").reduce(function (o, i) {
                    return o[i];
                  }, window);
                });
              }

              return _neptune2.default.liquid.engine.parseAndRender(item.template, data).then(function (rendered) {
                if (placement == "append") {
                  // item.el.innerHTML = item.el.innerHTML + rendered
                  // item.el.append(rendered)

                  var temp = document.createElement("div");
                  temp.innerHTML = rendered;
                  _n3.default.array(temp.childNodes).forEach(function (child) {
                    item.el.appendChild(child);
                  });
                } else if (placement == "prepend") {
                  // item.el.innerHTML = rendered + item.el.innerHTML
                  // item.el.prepend(rendered)

                  var temp = document.createElement("div");
                  temp.innerHTML = rendered;
                  _n3.default.array(temp.childNodes).reverse().forEach(function (child) {
                    item.el.insertBefore(child, item.el.firstChild);
                  });
                } else {
                  item.el.classList.add("liquid-rendering");

                  var focused = false;

                  if (!clearPermanent) {
                    var preserved = {};
                    _n3.default.qsa("[neptune-permanent]", item.el).forEach(function (np) {
                      if (!np.getAttribute("neptune-permanent")) return false;
                      np.setAttribute("permanent", np.getAttribute("neptune-permanent"));
                      preserved[np.getAttribute("neptune-permanent")] = np;
                    });
                  }

                  try {
                    if (item.el.contains(document.activeElement)) {
                      focused = _n3.default.rqs(document.activeElement);
                    }
                  } catch (err) {}

                  if (item.el.innerHTML != rendered) item.el.innerHTML = rendered;

                  if (!clearPermanent) {
                    _n3.default.qsa("[neptune-permanent]", item.el).forEach(function (np) {

                      if (!!np.parentNode.nodeName && !!preserved[np.getAttribute("neptune-permanent")]) {
                        np.parentNode.replaceChild(preserved[np.getAttribute("neptune-permanent")], np);
                      }
                    });
                  }

                  if (!!focused && _n3.default.exists(focused)) _n3.default.qs(focused).focus();

                  item.el.classList.remove("liquid-rendering");
                }

                _n3.default.trigger(document, 'template:rendered', false, true, { topic: topic, el: item.el, template: item.template, data: data });
                _n3.default.trigger(item.el, 'liquid:rendered', false, true, { topic: topic, el: item.el, template: item.template, data: data });

                _n3.default.qsa("script", item.el).forEach(function (script) {
                  try {
                    if (!!script.innerText) eval(script.innerText);
                  } catch (err) {}
                });
              });
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function (_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

_neptune2.default.liquid.attributes = {

  toRender: [],
  resizer: false,

  init: function init(p) {
    _neptune2.default.liquid.attributes.toRender = [];
    _n3.default.xp('//*[@*[starts-with(name(), "n:")]]').forEach(function (el) {

      el.n = {};

      for (var i = 0, atts = el.attributes, n = atts.length, arr = []; i < n; i++) {
        if (atts[i].nodeName.startsWith('n:')) {
          el.n[atts[i].nodeName.split('n:')[1]] = atts[i].nodeValue;
          _neptune2.default.liquid.attributes.toRender.push({ el: el, att: atts[i].nodeName.split('n:')[1], liquid: atts[i].nodeValue });
        }
      }
    });
    _neptune2.default.liquid.attributes.render();

    if (!_neptune2.default.liquid.attributes.resizer) {
      window.addEventListener('resized', function (e) {
        _neptune2.default.liquid.attributes.render(_neptune2.default.liquid.attributes.toRender.filter(function (r) {
          return ['sm:', 'md:', 'lg:', 'xl:', '2xl:'].some(function (v) {
            return r.liquid.includes(v);
          });
        }));
      });
      _neptune2.default.liquid.attributes.resizer = true;
    }
  },

  render: function render(R) {

    R = R || _neptune2.default.liquid.attributes.toRender;

    R.forEach(function (r) {
      var data = window;
      if (_n3.default.parents(r.el, '[neptune-liquid]')) {
        data = _neptune2.default.liquid.topics[_n3.default.parents(r.el, '[neptune-liquid]').topic].data;
      }
      _neptune2.default.liquid.engine.parseAndRender("{{ " + r.liquid + " }}", data).then(function (rendered) {

        if (rendered.trim() == '_remove') return r.el.removeAttribute(r.att);

        r.el.setAttribute(r.att, rendered);
      });
    });
  }

};

document.addEventListener("template:rendered", _neptune2.default.liquid.attributes.init);

_neptune2.default.templates = _neptune2.default.liquid; // legacy support
window.Neptune = _neptune2.default;

exports.default = _neptune2.default.liquid;